import MuiAvatar from '@mui/material/Avatar';

import { styled } from 'helpers';

import { AvatarProps } from './types';

export const Avatar = styled(MuiAvatar, {
  shouldForwardProp: (prop) => prop !== 'size' && prop !== 'backgroundColor',
})<AvatarProps>`
  background-color: ${({ theme, backgroundColor }) => {
    const backgroundColors = [
      theme.palette.orange[200],
      theme.palette.deepOrange[200],
      theme.palette.teal[200],
      theme.palette.green[200],
      theme.palette.lightGreen[300],
      theme.palette.red[100],
      theme.palette.purple[100],
      theme.palette.lightBlue[100],
      theme.palette.blue[200],
    ];

    return backgroundColor !== undefined ? backgroundColors[backgroundColor] : theme.palette.grey['A100'];
  }};
  color: ${({ theme, backgroundColor }) =>
    backgroundColor !== undefined ? theme.palette.text.primary : theme.palette.blueGrey['A300']};
  font-size: ${({ theme, size }) => {
    const fontSizeMap: { [s: number]: number } = {
      24: 8,
      32: 10,
      48: 14,
      56: 16,
      88: 24,
      120: 32,
    };

    return theme.typography.pxToRem(fontSizeMap[size as number]);
  }};
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
`;

export default Avatar;
